<template>
  <div>
    <v-alert type="warning" v-if="requiresManualClientInput || requiresManualProjectInput">
      <p class="mb-0 pb-0">
        {{ $vuetify.lang.t('$vuetify.cap_settings.warning.intro') }}
        <b v-if="requiresManualClientInput">{{ $vuetify.lang.t('$vuetify.cap_settings.client_name') }}</b><span
          v-if="requiresManualClientInput && requiresManualProjectInput"> & </span><b
          v-if="requiresManualProjectInput">{{ $vuetify.lang.t('$vuetify.cap_settings.project_id') }}</b>&nbsp;
        <span
            v-if="!client_not_in_list && !project_not_in_list">{{
            $vuetify.lang.t('$vuetify.cap_settings.warning.reason_server')
          }} <br/></span>
        <span
            v-if="client_not_in_list && !project_not_in_list">{{
            $vuetify.lang.t('$vuetify.cap_settings.warning.reason_client_not_listed')
          }}<br/></span>
        <span
            v-if="(project_not_in_list && !client_not_in_list)">{{
            $vuetify.lang.t('$vuetify.cap_settings.warning.reason_project_not_listed')
          }}<br/></span>
        <b>{{ $vuetify.lang.t('$vuetify.cap_settings.warning.dbl_check') }}</b><br/>
        <span
            style="font-size: 10px;">{{ $vuetify.lang.t('$vuetify.cap_settings.warning.admin_msg') }}</span>
      </p>
    </v-alert>

    <template v-if="!this.usesDataFromRRQRCode">
      <v-select
          v-if="display_client_select"
          v-model="current_client"
          :items="clients"
          item-text="display_name"
          :label="$vuetify.lang.t('$vuetify.cap_settings.client_select_placeholder')"
          return-object
          @change="changed_client_select"
          :disabled="formDisabled"
          :rules="clientSelectRules"
          required
      ></v-select>

      <v-select
          v-if="display_project_select"
          v-model="current_project"
          :items="projects"
          item-text="display_name"
          :label="$vuetify.lang.t('$vuetify.cap_settings.project_select_placeholder')"
          return-object
          @change="changed_project_select"
          :disabled="formDisabled"
          :rules="nameRules"
          required
      >
      </v-select>

      <v-text-field
          v-if="requiresManualClientInput"
          v-model="unverifiedClient.name"
          :maxlength="200"
          :label="$vuetify.lang.t('$vuetify.cap_settings.client_name')"
          :rules="clientProjectManualInputRules"
          @change="emit_changes_to_parent"
          required
      ></v-text-field>


      <v-text-field
          v-if="requiresManualProjectInput"
          v-model="unverifiedProject.name"
          :maxlength="200"
          :rules="clientProjectManualInputRules"
          :label="$vuetify.lang.t('$vuetify.cap_settings.project_id')"
          @change="emit_changes_to_parent"
          required
      ></v-text-field>
    </template>
    <!-- This template is used when data comes from Risk Reflex QRCode -->
    <template v-if="this.usesDataFromRRQRCode">
      <v-select
          v-if="display_project_select"
          v-model="current_project"
          :items="projects"
          item-text="display_name"
          :label="$vuetify.lang.t('$vuetify.cap_settings.project_select_placeholder')"
          return-object
          :rules="nameRules"
          disabled
      >
      </v-select>
      <v-select
          v-if="display_client_select"
          v-model="current_client"
          :items="clients"
          item-text="display_name"
          :label="$vuetify.lang.t('$vuetify.cap_settings.client_select_placeholder')"
          return-object
          @change="changed_rr_qr_client_select"
          :disabled="formDisabled || lockClientSelect"
          :rules="clientSelectRules"
          required
      ></v-select>
    </template>
    <r-r-q-r-error-popup
        :is-visible="display_rrqr_error_popup"
        :title="$vuetify.lang.t('$vuetify.cap_settings.rrqrcode.error_popup_notice_manual_mode.title')"
        :body="$vuetify.lang.t('$vuetify.cap_settings.rrqrcode.error_popup_notice_manual_mode.body')"
        :custom_positive_btn_text="$vuetify.lang.t('$vuetify.global.ok')"
        @positive_btn_clicked="closeRRQRErrorAndForceManualMode"
    ></r-r-q-r-error-popup>
  </div>
</template>

<script>
import {AppBoundDataStorageHelper} from "@/helpers/LocalStorageHelpers/AppBoundDataStorageHelper";
import appSettings from "@/mixins/config/appSettings";
import resourcesApi from "@/api/resources/resourcesApi";
import {RRQrCodeReturnTypeGlobalProject} from "@/helpers/RiskReflexQRCodeHelpers/RiskReflexQRCodeReturnTypes";
import SimplePopupComponent from "@/components/modules/global/simplePopup/SimplePopupComponent";

export const ClientListStoreKey = 'CAP_CLIENT_LIST';

export default {
  name: "CAPSelectorComponent",
  components: {RRQRErrorPopup:SimplePopupComponent},
  props: {
    formDisabled : {
      type : Boolean
    },
    usesDataFromRRQRCode : {
      type : Boolean,
      default : false
    },
     RRQRCodeJsonData : {
      type : JSON
    }
  },
  mixins: [appSettings],
  data: () => {
    return {
      is_loading_clients: false,
      is_loading_projects: false,
      viewGettingDestroyed : false,
      clients: [],
      projects: [],
      current_client: null,
      current_project: null,
      stored_data: {
        client: null,
        project: null,
      },
      final_data: {
        client: null,
        project: null,
      },
      unverifiedClient: {id: null, name: null},
      unverifiedProject: {id: null, name: null},
      clients_load_data_error_critical: false,
      projects_load_error: false,
      client_not_in_list: false,
      project_not_in_list: false,
      display_rrqr_error_popup : false,
      lockClientSelect : false
    }
  },
  methods: {
    /* DROPDOWN HANDLING !!!!  */
    /* CLIENTS SECTION */
   async  get_clients() {
      this.reset_get_client_params();
     await resourcesApi.getActiveClients()
          .then(response => {
            let list = this.clean_client_list(response.data);
            if (list.length > 0) {
              this.build_client_select(list);
              this.save_client_list(response.data);
            } else {
              this.load_clients_from_local_storage();
            }
            this.setClientsLoadingState(false);
          }).catch(() => {
        this.load_clients_from_local_storage();
        this.setClientsLoadingState(false);
      })
    },
    reset_get_client_params() {
      this.clients_load_data_error_critical = false;
      this.setClientsLoadingState(true);
    },
    build_client_select(list_data) {
      this.clients = list_data;
      //DO NOT TRIGGER WHEN USING RRQRCODE
      if(!this.usesDataFromRRQRCode) {
        this.select_current_saved_client();
      }
    },
    load_clients_from_local_storage() {
      try {
        let local_data = AppBoundDataStorageHelper.getAppBoundDataForKey(ClientListStoreKey);
        if (local_data.length > 0) {
          this.build_client_select(local_data);
        } else {
          this.clients_load_data_error_critical = true;
        }
      } catch (error) {
        this.clients_load_data_error_critical = true;
      }
    },
    // SAVING CLIENT LIST
    //TODO CHECK NEEDED
    save_client_list(list) {
      if (list >= 0) {
        AppBoundDataStorageHelper.storeAppBoundDataForKey(ClientListStoreKey, list);
      }
    },
    clean_client_list(data) {
      let list = [];
      if (data !== undefined && data !== null && Array.isArray(data)) {
        for (const index in data) {
          if (this.is_valid_client(data[index])) {
            data[index]['display_name'] = data[index]['name'];
            list.push(data[index]);
          }
        }
        //DO NOT ADD WHEN USING DATA FROM RRQRCODE
        if(!this.usesDataFromRRQRCode){
          list.push({
            id: -1,
            name: null,
            display_name: this.$vuetify.lang.t('$vuetify.cap_settings.client_not_in_list_label')
          })
        }
      }
      return list;
    },
    //CHECKED
    is_valid_client(item) {
      if (item.id !== undefined && item.name !== undefined) {
        return true;
      }
      return false;
    },
    select_current_saved_client() {
      if (this.stored_data.client !== null && typeof this.stored_data.client === 'object') {
        this.current_client = this.clients.find(
            (item) => {
              if (item['id'] === null && item['name']) {
                return false;
              }
              return (item['id'] === this.stored_data.client.id || item['name'] == this.stored_data.client.name) ? true : false;
            }
        );
        if (this.current_client !== undefined && typeof this.current_client === 'object') {
          //Temporary set it as final data...
          this.final_data.client = this.current_client;
          //Emit the data to the parent
          this.emitChangedClient();
          //TRIGGER THE CHANGE
          this.get_projects_for_client();
        }
      }
    },
    changed_client_select() {
      //Get new items
      this.get_projects_for_client();

      //INFORM PARENT
      this.final_data.client = this.current_client;
      this.final_data.project = null;

      if (this.client_not_in_list) {
        //PROVIDE USER WITH LATEST STORED DATA FOR CLIENT AND PROJECT ...
        this.final_data.client = this.stored_data.client;
        this.final_data.project = this.stored_data.project;
      }

      //update parent :
      this.emit_changes_to_parent();

    },
    /* PROJECTS SECTION */
    async get_projects_for_client() {
      if (this.current_client !== null) {
        this.reset_get_project_params();

        if (this.current_client.id === -1) {
          this.handle_client_not_in_list();
          return false;
        }

        //DISPLAY LOADING ...
        this.setProjectsLoadingState(true);

        await resourcesApi.getActiveProjectsForClient(this.current_client.id)
            .then(response => {
              //window.console.log('LOADED');
              let list = this.clean_project_list(response.data);
              if (list.length > 0) {
                this.build_project_select(list);
                //this.save_client_list(responseData); //was commented out
              } else {
                //this.load_clients_from_local_storage(); //was commented out
                this.projects_load_error = true;
              }
              this.setProjectsLoadingState(false);
            }).catch(() => {
          //this.load_clients_from_local_storage();
          this.projects_load_error = true;
          this.setProjectsLoadingState(false);
        });
      }
    },
    handle_client_not_in_list() {
      //TRIGGER NOT IN LIST
      this.client_not_in_list = true;
      //RESET PROJECTS ARRAY
      this.projects = [];
      //TRIGGER ERROR
      this.projects_load_error = true;
      // Since it's not on server ... duh ...
      //PROVIDING STORED AS FALLBACK IN changed_client_select FUNCTION
      //PROVIDE LAST STORED VALUE ?

    },
    reset_get_project_params() {
      //RESET ERROR
      this.projects_load_error = false;
      //RESET CLIENT NOT IN LIST STUFF...
      this.client_not_in_list = false;
      //ALSO RESET PROJECT NOT IN LIST
      this.reset_project_nil_params();
    },
    build_project_select(list_data) {
      this.projects = list_data;
      //DO NOT TRIGGER WHEN USING RRQRCODE
      if(!this.usesDataFromRRQRCode) {
        this.select_current_saved_project();
      }
    },
    clean_project_list(data) {
      let list = [];
      if (data !== undefined && data !== null && Array.isArray(data)) {
        for (const index in data) {
          if (this.is_valid_project(data[index])) {
            data[index]['display_name'] = data[index]['name'];
            list.push(data[index]);
          }
        }
        //DO NOT ADD WHEN USING DATA FROM RRQRCODE
        if(!this.usesDataFromRRQRCode) {
          list.push({
            id: -1,
            name: null,
            display_name: this.$vuetify.lang.t('$vuetify.cap_settings.project_not_in_list_label')
          })
        }
      }
      return list;
    },
    is_valid_project(item) {
      if (item.id !== undefined && item.name !== undefined) {
        return true;
      }
      return false;
    },
    select_current_saved_project() {
      if (this.stored_data.project !== null && typeof this.stored_data.project === 'object') {
        this.current_project = this.projects.find(
            (item) => {

              if (item['id'] === null && item['name']) {
                return false;
              }

              return (item['id'] === this.stored_data.project.id || item['name'] == this.stored_data.project.name) ? true : false;

            }
        );

        if (this.current_project !== null && typeof this.current_project === 'object') {
          //Temporary set it as final data...
          this.final_data.project = this.current_project;
          //EMIT THE CHANGE TO THE PARENT
          this.emitChangedProject();
        }
      }
    },
    changed_project_select() {
      //CHANGED PROJECT SO RESET
      this.reset_project_nil_params();

      if (this.current_project.id === -1) {
        this.project_not_in_list = true;
      }

      this.final_data.project = this.current_project;

      if (this.project_not_in_list) {
        this.final_data.project = this.stored_data.project;
      }

      this.emit_changes_to_parent();
    },
    reset_project_nil_params() {
      this.project_not_in_list = false;
    },
    emit_changes_to_parent() {
      this.emitChangedClient();
      this.emitChangedProject();
    },
    emitChangedClient() {
      let $client = (this.requiresManualClientInput) ? this.unverifiedClient : this.final_data.client;
      window.console.log('emitting Client');
      window.console.log($client);
      this.$emit('changedClient', $client);
    },
    emitChangedProject() {
      let $project = (this.requiresManualProjectInput) ? this.unverifiedProject : this.final_data.project
      window.console.log('emitting PROJECT');
      window.console.log($project);
      this.$emit('changedProject', $project);
    },
    /* This part is to handle the loading message for some reason it missfired sometimes when reloading page*/
    setClientsLoadingState(state){
      this.is_loading_clients = state;
      this.updateLoadingResourcesState(state);
    },
    setProjectsLoadingState(state){
      this.is_loading_projects = state;
      this.updateLoadingResourcesState(state);
    },
    //UPDATE LOADING STATE SO APP IS AWARE OF LOADING
    async updateLoadingResourcesState(){
      //WHEN YOU CHANGE THIS FUNCTION setLoadingResourceState for some reason don't forget the beforeDestroy
      if(this.isLoading && !this.viewGettingDestroyed){
        await this.$store.dispatch('setLoadingResourceState', true);
      }else{
        await this.$store.dispatch('setLoadingResourceState', false);
      }
    },
    /* RRQR FUNCITONS */
    async loadRRQRCodeData($RRQRCodeJsonData){
      this.setProjectsLoadingState(true);
      switch ($RRQRCodeJsonData.qrt){
        case RRQrCodeReturnTypeGlobalProject:
          await resourcesApi.getProjectDetailsWithLinkedClientsDetails($RRQRCodeJsonData.proj)
              .then(response => {
                this.handleProjectDetailsWithLinkedClientsDetails(response.data);
                this.setProjectsLoadingState(false);
              }).catch(()=>{
                this.display_rrqr_error_popup = true;
                this.setProjectsLoadingState(false);
              })
          break;
      }
    },
    handleProjectDetailsWithLinkedClientsDetails($projectDetails){
      //BUILD THE PROJECT LIST ( ONLY CONTAINS ONE ITEM )
      let project_list = this.clean_project_list([$projectDetails]);
      this.build_project_select(project_list);
      //WARNING!!!! ALSO SET THE FINAL DATA FOR PROJECT!!!!
      this.final_data.project = this.current_project = project_list[0];
      this.emitChangedProject();

      //BUILD THE CLIENT LIST HERE !!!
      let client_list = this.clean_client_list($projectDetails.linked_clients);
      this.build_client_select(client_list)
      //WHEN THERE IS ONLY ONE CLIENT!
      //RESET CLIENT DATA!
      this.final_data.client = this.current_client = null;
      if($projectDetails.linked_clients.length == 1){
        this.lockClientSelect = true;
        //WARNING!!!! ALSO SET THE FINAL DATA FOR CLIENT!!!!
        this.final_data.client = this.current_client = client_list[0];
        this.emitChangedClient();
      }
    },
    changed_rr_qr_client_select() {
      this.final_data.client = this.current_client;
      //update parent :
      window.console.log(this.final_data);
      this.emit_changes_to_parent();
    },
    closeRRQRErrorAndForceManualMode(){
      //IMPORTANT Emit the failed to the parent to trigger the data change
      this.$emit('errorLoadingRRQRData');
      this.display_rrqr_error_popup = false;
    }
  },
  computed: {
    isLoading: function(){
      let $state = (this.is_loading_clients || this.is_loading_projects)? true : false
      this.$emit('loadingStateChanged', $state)
      return $state
    },
    clientSelected: function () {
      return (this.current_client !== null && this.current_client !== undefined) ? true : false;
    },
    clientProjectManualInputRules() {
      const rules = [];
      const min_length_rule =
          v => (v || '').length >= 2 || this.$vuetify.lang.t('$vuetify.global.mandatory_field')
      rules.push(min_length_rule)
      return rules;
    },
    clientSelectRules() {
      const rules = [];
      const rule = v => (v !== null && v !== undefined && typeof v === 'object' && v.name !== undefined && v.id !== undefined) || this.$vuetify.lang.t('$vuetify.cap_settings.input_errors.no_client_selected');
      rules.push(rule);
      return rules;
    },
    projectSelectRules() {
      const rules = [];
      const rule = v => (v !== null && v !== undefined && typeof v === 'object' && v.name !== undefined && v.id !== undefined) || this.$vuetify.lang.t('$vuetify.cap_settings.input_errors.no_project_selected');
      rules.push(rule);
      return rules;
    },
    display_client_select() {
      if(this.usesDataFromRRQRCode){
        //When Using Data from QR Code
        //window.console.log('DCS -> RRQR');
        return (this.projectSelected && !this.projects_load_error)? true : false
      }else{
        //Default behavior manual input..
        //window.console.log('DCS -> DEF');
        return (this.clients_load_data_error_critical) ? false : true;
      }
    },
    display_project_select() {
      if(this.usesDataFromRRQRCode){
        //When Using Data from QR Code
        //window.console.log('DPS -> RRQR');
        return (this.projects_load_error) ? false : true;
      }else{
        //Default behavior manual input..
        //window.console.log('DPS -> DEF');
        return (this.clientSelected && !this.projects_load_error && !this.clients_load_data_error_critical);
      }
    },
    requiresManualClientInput() {
      return (this.clients_load_data_error_critical || this.client_not_in_list);
    },
    requiresManualProjectInput() {
      return (this.clients_load_data_error_critical || this.projects_load_error || this.client_not_in_list || this.project_not_in_list);
    },
    projectSelected(){
      return (this.current_project !== null && this.current_project !== undefined) ? true : false;
    }
  },
  watch: {
    is_loading_clients: function ($newValue) {
      if (!$newValue) {
        //window.console.log('ENDED LOADING CLIENTS');
        if(this.requiresManualClientInput){
          //window.console.log('CLIENT REQUIRES MANUAL INPUT!!');
          //EMIT CHANGES HERE !! THIS WILL TRIGGER UNVERIFIED OBJECTS!!
          this.emit_changes_to_parent();
        }
      }
    },
    is_loading_projects: function ($newValue) {
      if (!$newValue) {
        //window.console.log('ENDED LOADING PROJECTS');
        if(this.requiresManualProjectInput){
          //window.console.log('PROJECT REQUIRES MANUAL INPUT!!');
          //AT THIS POINT WE EMIT THE PROJECT ONLY
          this.emitChangedProject();
        }
      }
    }
  },
 async mounted() {
    //window.console.log('CAPS SELECTOR COMPONENT I GOT MOUNTED !!!!')
    this.stored_data.client = this.$store.state.currentClientProjectSettings.client;
    this.stored_data.project = this.$store.state.currentClientProjectSettings.project;

    //FILL FINAL DATA ... also launch pass to parent view here
    this.final_data.client = this.stored_data.client;
    this.final_data.project = this.stored_data.project;

    //TEST UNLISTED CLIENT / PROJECT
    this.unverifiedClient.name = ((this.stored_data.client !== undefined && this.stored_data.client !== null) && this.stored_data.client.name !== undefined) ? this.stored_data.client.name : null
    this.unverifiedProject.name = ((this.stored_data.project !== undefined && this.stored_data.project !== null) && this.stored_data.project.name !== undefined) ? this.stored_data.project.name : null

    if(!this.usesDataFromRRQRCode){
      this.get_clients();
    }
  },
  async beforeDestroy() {
    this.viewGettingDestroyed = true;
  },
}
</script>

<style scoped>

</style>